var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSneakerOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4892 20.9591C26.1544 23.2192 24.1576 25 21 25L15.5068 25C13.6355 25 11.842 24.2507 10.5269 22.9193L3.2895 15.5927C1.59332 13.8757 1.55384 11.1262 3.20001 9.36112L8.03733 4.17436C9.27566 2.84658 11.5 3.72285 11.5 5.53845L11.5 6.00003C11.5 6.55232 11.9477 7.00003 12.5 7.00003L15.0647 7.00003L14.6434 5.22621L14.6433 5.22552C14.5157 4.68831 14.8476 4.14937 15.3848 4.02159C15.9219 3.89382 16.461 4.22558 16.589 4.76269L16.5891 4.76338L16.5892 4.76372L18.586 13.1452C18.7464 13.818 19.243 14.3603 19.8992 14.579L22.8162 15.5513C25.4882 16.442 26.8161 18.7527 26.4892 20.9591ZM15.5425 9.00003L15.8177 10.1549L12.7253 11.0385C12.1942 11.1902 11.8867 11.7437 12.0384 12.2747C12.1902 12.8058 12.7437 13.1133 13.2747 12.9615L16.2816 12.1024L16.6405 13.6087C16.6867 13.8025 16.7468 13.9909 16.8198 14.1727L15.6838 14.5514C15.1598 14.726 14.8766 15.2923 15.0513 15.8163C15.2259 16.3402 15.7923 16.6234 16.3162 16.4487L18.0967 15.8552C18.4446 16.1222 18.8387 16.3337 19.2667 16.4764L22.1837 17.4487C24.0118 18.058 24.6839 19.4974 24.5108 20.666C24.3456 21.7808 23.3424 23 21 23L15.5068 23C14.1701 23 12.8891 22.4648 11.9497 21.5138L4.71235 14.1872C3.77003 13.2333 3.74809 11.7058 4.66263 10.7252L9.49995 5.53845L9.49995 6.00003C9.49995 7.65689 10.8431 9.00004 12.5 9.00004L15.5425 9.00003Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSneakerOutline);
export default __webpack_public_path__ + "static/media/sneaker_outline.b762c1404ca39ae9820345b4b92d572d.svg";
export { ForwardRef as ReactComponent };